"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = {
            choosenDates: [],
            canContinue: false,
            enrolling: false,
            alert: null
        };
    },
    canContinue: function () {
        this.state.alert = null;
        if (Array.isArray(this.input.schedules) && this.input.schedules.length > 1 && !this.state.choosenDates.length) {
            this.state.canContinue = false;
            this.state.alert = 'Select at least one of the scheduled dates';
            return false;
        }
        return this.state.canContinue = true;
    },
    onChoosenSchedule: function (dates) {
        this.state.choosenDates = dates;
        this.canContinue();
    },
    onContinue: async function (e) {
        if (e.target.disabled || !this.canContinue())
            return;
        const payload = {
            type: this.input.type,
            id: this.input[this.input.type + 'Id']
        };
        if (this.state.choosenDates.length)
            payload.dates = this.state.choosenDates;
        else if (Array.isArray(this.input.schedules) && this.input.schedules.length == 1)
            payload.dates = this.input.schedules;
        this.state.enrolling = true;
        try {
            const {error, message, enrollmentId, inPackage} = await Request('/enrollment/add', 'POST', payload);
            if (error)
                throw new Error(message);
            this.state.enrolling = false;
            !inPackage && this.input.price && this.input.price.amount ? this.emit('make-payment', enrollmentId) : this.emit('done', enrollmentId);
        } catch (error) {
            console.log('Enrollment Failed: ', error);
            this.state.enrolling = false;
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Preview/components/EnrolModal.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Caption_template = require("./Caption.marko"),
    Caption_tag = marko_loadTag(Caption_template),
    Certificates_template = require("./Certificates.marko"),
    Certificates_tag = marko_loadTag(Certificates_template),
    ChooseDate_template = require("./ChooseDate.marko"),
    ChooseDate_tag = marko_loadTag(ChooseDate_template),
    Schedules_template = require("../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    Preloader_template = require("../../../../components/Preloader/index.marko"),
    Preloader_tag = marko_loadTag(Preloader_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "position-absolute zindex-1 w-100 vh-100 top-0"
      },
    marko_attrs1 = {
        "class": "position-absolute top-0 w-100 h-100 theme-bg-transparent animated fadeIn faster"
      },
    marko_attrs2 = {
        "class": "mt-0"
      },
    marko_attrs3 = {
        "class": "font-medium-2"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("77004e"),
    marko_node0 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "14", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node2 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "text-right"
      },
    marko_attrs5 = {
        "class": "btn btn-secondary btn-lg mx-25"
      },
    marko_node3 = marko_createElement("br", null, "22", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "23", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  const smallScreen = ['xs', 'sm'].includes( GState.get('screen').media )

  out.be("div", marko_attrs0, "0", component);

  out.e("div", marko_attrs1, "1", component, 0, 0, {
      onclick: __component.d("click", () => component.emit('cancel'), false)
    });

  AutoScroll_tag({
      class: "m-0 w-100 d-flex justify-content-center overflow-auto no-scrollbar",
      renderBody: function(out) {
        WSAdapt_tag({
            ns: "col-md-5 col-12",
            qs: "col-md-6 col-12",
            hs: "col-md-7 col-12",
            class: "animated zoomIn faster",
            style: smallScreen ? "padding:5rem 8%;" : "padding:14rem 8%;",
            renderBody: function(out) {
              out.be("h4", marko_attrs2, "4", component);

              Locale_tag({
                  text: "Enrol for"
                }, out, __component, "5");

              out.t(" ");

              Locale_tag({
                  text: input.name,
                  class: "text-primary"
                }, out, __component, "6");

              out.t(" ");

              Locale_tag({
                  text: input.type
                }, out, __component, "7");

              out.ee();

              out.e("p", marko_attrs3, "8", component, 1)
                .t(input.description, component);

              Caption_tag(input, out, __component, "9");

              Certificates_tag({
                  list: input.certificates
                }, out, __component, "10");

              if (Array.isArray(input.schedules) && (input.schedules.length > 1)) {
                ChooseDate_tag({
                    list: input.schedules
                  }, out, __component, "11", [
                  [
                    "select",
                    "onChoosenSchedule",
                    false
                  ]
                ]);
              } else {
                Schedules_tag({
                    list: input.schedules
                  }, out, __component, "12");
              }

              out.n(marko_node0, component);

              out.n(marko_node1, component);

              out.n(marko_node2, component);

              out.be("div", marko_attrs4, "16", component);

              out.be("button", marko_attrs5, "17", component, null, 0, {
                  onclick: __component.d("click", () => component.emit('cancel'), false)
                });

              Locale_tag({
                  text: "Cancel"
                }, out, __component, "18");

              out.ee();

              out.be("button", {
                  "class": "btn btn-primary btn-lg mx-25",
                  disabled: !component.canContinue()
                }, "19", component, null, 0, {
                  onclick: __component.d("click", "onContinue", false)
                });

              Locale_tag({
                  text: "Continue"
                }, out, __component, "20");

              Preloader_tag({
                  active: state.enrolling,
                  class: "font-medium-5 float-right"
                }, out, __component, "21");

              out.ee();

              out.ee();

              out.n(marko_node3, component);

              out.n(marko_node4, component);
            }
          }, out, __component, "3");
      }
    }, out, __component, "2");

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
